// removed by extract-text-webpack-plugin
module.exports = {"root":"root___4W1E9"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Operation/Merchant/components/BaseInfo/Index.less
// module id = LBvS
// module chunks = 3 4